import * as React from 'react';
import AdvertisingOptionFull from './components/AdvertisingOptionFull';
import commit from './orchestration/commit';
import reset from './orchestration/reset';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import isDirty from './selectors/isDirty';
import { isGdprAdMarket, areAdsEnabled } from 'owa-mail-ads-shared';
var AdvertisingOption = {
    key: 'advertising_options',
    titleStringKey: 'optionTitle_ads',
    searchTermsStringKey: 'optionTitle_ads',
    fullOptionFormSettings: {
        render: function () { return React.createElement(AdvertisingOptionFull, null); },
        isDirty: isDirty,
        onSave: commit,
        onDiscard: reset,
    },
    isHidden: function () {
        return !(isControlFeatureEnabled('fwk-gdprAdsPrefs') && isGdprAdMarket() && areAdsEnabled());
    },
};
export default AdvertisingOption;
//# sourceMappingURL=AdvertisingOption.js.map